import React from "react";

const LayoutIcon = ({ children }) => {
  return (
    <div className="flex w-[86px] items-center justify-center rounded-full bg-yellow aspect-1">
      {children}
    </div>
  )
}

export default LayoutIcon;
